module.exports = __webpack_public_path__ + "img/组 1122@2x.7a5e5393.png";